import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { eur, num, fmtDate, fmtTime } from "@/lib/format";
import { StatusBadge } from "@/components/common/StatusBadge";
import { PortalReferralCard } from "@/components/portal/PortalReferralCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, CalendarPlus, Award, Gift, Wallet, Package } from "lucide-react";

export default function PortalHome() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/portal/home").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--hi-gold))]" /></div>;
  const na = d.next_appointment;
  return (
    <div className="space-y-5">
      <div><h1 className="font-heading text-3xl font-semibold">Ciao {d.client.first_name}</h1><p className="text-sm text-muted-foreground">Bentornata nella tua area Hair Identity</p></div>

      <Card className="p-5 hi-plaque text-[hsl(36_44%_96%)]">
        <div className="text-xs uppercase tracking-wider opacity-70 mb-2">Prossimo appuntamento</div>
        {na ? (
          <div>
            <div className="font-heading text-2xl font-semibold">{fmtDate(na.start, { weekday: "long", day: "2-digit", month: "long" })}</div>
            <div className="text-lg">{fmtTime(na.start)} · {na.operator_name || "Primo disponibile"}</div>
            <div className="text-sm opacity-80 mt-1">{(na.service_names || []).join(", ")}</div>
            <div className="flex items-center gap-3 mt-3">
              <span className="text-sm">{eur(na.price)}</span>
              <button onClick={() => nav("/portale/appuntamenti")} className="text-sm underline decoration-[hsl(42_60%_52%)] underline-offset-4" data-testid="home-manage-appointment">Gestisci</button>
            </div>
          </div>
        ) : (
          <div><div className="text-lg">Nessun appuntamento in programma</div><Button className="mt-3 bg-[hsl(42_60%_52%)] text-black hover:bg-[hsl(42_66%_56%)]" onClick={() => nav("/portale/prenota")}>Prenota ora</Button></div>
        )}
      </Card>

      <div className="grid grid-cols-2 gap-3">
        <Card className="p-4"><div className="flex items-center gap-2 text-muted-foreground text-xs"><Award className="h-4 w-4" /> Punti Identity Rewards</div><div className="font-heading text-2xl font-semibold mt-1">{num(d.stats.points)}</div></Card>
        <Card className="p-4"><div className="flex items-center gap-2 text-muted-foreground text-xs"><Wallet className="h-4 w-4" /> Credito</div><div className="font-heading text-2xl font-semibold mt-1">{eur(d.stats.credit)}</div></Card>
        <Card className="p-4"><div className="flex items-center gap-2 text-muted-foreground text-xs"><Gift className="h-4 w-4" /> Gift Card</div><div className="font-heading text-2xl font-semibold mt-1">{eur(d.stats.giftcard_balance)}</div></Card>
        <Card className="p-4"><div className="flex items-center gap-2 text-muted-foreground text-xs"><Package className="h-4 w-4" /> Pacchetti attivi</div><div className="font-heading text-2xl font-semibold mt-1">{d.packages.length}</div></Card>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Button size="lg" onClick={() => nav("/portale/prenota")} data-testid="home-book-button"><CalendarPlus className="h-5 w-5 mr-2" /> Prenota</Button>
        <Button size="lg" variant="outline" onClick={() => nav("/portale/wallet")} data-testid="home-wallet-button"><Gift className="h-5 w-5 mr-2" /> Wallet</Button>
      </div>

      <PortalReferralCard />
    </div>
  );
}
